import { CommonModule } from '@angular/common';
import { TopicRoutingModule } from './topic-routing.module';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { ExercisesComponent } from './exercises/exercises.component';
import { FormsModule } from '@angular/forms';
import { TopicService } from './topic.service';
import { LanguageProvider } from './language.provider';
import { TopicComponent } from './topic/topic.component';
import { TExercisesComponent } from './t-exercises/t-exercises.component';
import { DndModule } from 'ng2-dnd';
import { TAllExercisesComponent } from './t-all-exercises/t-all-exercises.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../shared/shared.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClairvoyantComponent } from './clairvoyant/clairvoyant.component';
import { CardsComponent} from './cards/cards.component';
import { ClairvoyantTwoPlayerComponent } from './clairvoyant-two-player/clairvoyant-two-player.component';
import { CardsTouchComponent } from './cards-touch/cards-touch.component';
import { CardsColorComponent } from './cards-color/cards-color.component';
import { ClairvoyantColorTwoPlayerComponent } from './clairvoyant-color-two-player/clairvoyant-color-two-player.component';
import { ClairvoyantColorBitsComponent } from './clairvoyant-color-bits/clairvoyant-color-bits.component';
import { ClairvoyantChangeTwoPlayerComponent } from './clairvoyant-change-two-player/clairvoyant-change-two-player.component';
import { CardsTableComponent } from './cards-table/cards-table.component';
import { SymbolsEncodingComponent } from './symbols-encoding/symbols-encoding.component';
import { DefectEncodingComponent } from './defect-encoding/defect-encoding.component';
import { GoodOrBadEncodingComponent } from './good-or-bad-encoding/good-or-bad-encoding.component';

@NgModule({
  imports: [
    CommonModule,
    TopicRoutingModule,
    FormsModule,
    DndModule,
    BrowserAnimationsModule,
    NgbModule,
    NgxChartsModule,
    SharedModule
  ], providers: [TopicService,
    LanguageProvider,
    {provide: APP_INITIALIZER, useFactory: languageProviderFactory, deps: [LanguageProvider], multi: true}],
  declarations: [
    ExercisesComponent,
    TopicComponent,
    TExercisesComponent,
    TAllExercisesComponent,
    ClairvoyantComponent,
    CardsComponent,
    ClairvoyantTwoPlayerComponent,
    CardsTouchComponent,
    CardsColorComponent,
    ClairvoyantColorTwoPlayerComponent,
    ClairvoyantColorBitsComponent,
    ClairvoyantChangeTwoPlayerComponent,
    CardsTableComponent,
    SymbolsEncodingComponent,
    DefectEncodingComponent,
    GoodOrBadEncodingComponent,
  ]
})
export class CardtricksModule { }

export function languageProviderFactory(provider: LanguageProvider) {
  return () => provider.load();
}
